export const dateToMonthAndYear = (date, month = 'short', year = 'numeric') =>
  `${new Date(date).toLocaleString('en-US', {
    timeZone: 'UTC',
    month,
    year,
  })}`;

export const formatYearRange = (dateFrom, dateTo) => {
  if (!dateFrom && !dateTo) return '';

  const getYear = (date) => new Date(date).toLocaleString('en-US', { timeZone: 'UTC', year: 'numeric' });

  const fromYear = dateFrom ? getYear(dateFrom) : null;
  const toYear = dateTo ? getYear(dateTo) : null;

  if (fromYear && toYear) {
    if (fromYear === toYear) {
      return fromYear;
    }
    return `${fromYear} - ${toYear}`;
  }

  if (fromYear) {
    return `${fromYear} - `;
  }

  return toYear;
};
